import React from 'react';
import { useHistory } from 'react-router';
import Translate from '@spordle/intl-elements';

export const BackButton = () => {
  const history = useHistory();
  if (history?.length <= 1) return null;

  return <button className="btn btn-link" onClick={() => history.goBack()}>⇐ <Translate id="common.lang.back" /></button>
}
